import { render, staticRenderFns } from "./NotPayPage.vue?vue&type=template&id=7def6045&scoped=true"
import script from "./NotPayPage.vue?vue&type=script&lang=js"
export * from "./NotPayPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7def6045",
  null
  
)

export default component.exports